export const prettyJsonStringifyObjectWithErrors = (value: unknown): string =>
  JSON.stringify(value, errorReplacer, 2);

const errorReplacer = (_key: string, value: unknown) => {
  if (value instanceof Error) {
    return {
      ...value,
      name: value.name,
      message: value.message,
    };
  }

  return value;
};
